"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-misleading-character-class */
/* eslint-disable no-control-regex */
const sanitize = (input) => {
    input = input.split(/\r\n/g).join('\n');
    input = input.split(/\r/g).join('\n');
    // remove null bytes
    input = input.split(/\x00/g).join('');
    // strip control characters \u0000 - \u0020 except for tab and newline
    input = input.split(/[\u0000-\u0008\u000A-\u000C]/g).join('');
    input = input.split(/[\u000E-\u001F]/g).join('');
    // strip unicode zero width spaces
    input = input.split(/[\u200b|\u200c|\u200d\uFEFF\u007F]/g).join('');
    // escape html
    input = input.split(/&/g).join('&amp;');
    input = input.split(/"/g).join('&#34;');
    input = input.split(/'/g).join('&#39;');
    input = input.split(/</g).join('&lt;');
    input = input.split(/>/g).join('&gt;');
    return input;
};
exports.default = sanitize;
